import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Row, Divider } from 'antd';
import { formatDate } from '@/components/ui/Modals/utils';
import { useResolution886Report } from '@/context/Resolution886Report';
import { getValueOrDefault, useGetGeneralInformation } from './hooks/useGetGeneralInformation';

import * as S from './styles';

export const GeneralInformation = () => {
	const { report, selectedReviewId } = useResolution886Report();
	const { generalInformation } = useGetGeneralInformation(report, selectedReviewId);

	return (
		<Row gutter={[24, 24]}>
			<Col span={24}>
				<S.CustomTitle style={{ marginBottom: '1.5rem' }}>{I18n.get('General information')}</S.CustomTitle>
			</Col>

			<Col span={11}>
				<Row gutter={[0, 16]}>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Company')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.company)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Industrial Site')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.industrialSite)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Sector')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.sector)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Line')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.line)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Work position')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.workPosition)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Activity (task)')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.activity)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Name of evaluation')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.nameOfEvaluation)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>
							{I18n.get('Date of initial version')}:
						</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(formatDate(generalInformation?.dateOfInitialVersion || ''))}
						</S.StyledText>
					</Col>
				</Row>
			</Col>

			<Col span={1}>
				<Divider type="vertical" style={{ height: '100%', borderColor: '#D9D9D9' }} />
			</Col>

			<Col span={11}>
				<Row gutter={[0, 16]}>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Version')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.version)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Number of workers')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.numberOfWorkers)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Name of worker(s)')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.nameOfWorkers)}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>
							{I18n.get('Written work procedure')}:
						</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{generalInformation?.writtenWorkProcedure === 'Yes' ? I18n.get('Yes') : I18n.get('No')}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Training')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{generalInformation?.training === 'Yes' ? I18n.get('Yes') : I18n.get('No')}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>{I18n.get('Early manifestation')}:</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{generalInformation?.earlyManifestation === 'Yes' ? I18n.get('Yes') : I18n.get('No')}
						</S.StyledText>
					</Col>
					<Col span={24}>
						<S.StyledText style={{ fontWeight: 'bold' }}>
							{I18n.get('Location of the symptom')}:
						</S.StyledText>
						<S.StyledText style={{ marginLeft: '8px' }}>
							{getValueOrDefault(generalInformation?.locationOfSymptom)}
						</S.StyledText>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};
